{
    "api_keys": {
        "copied": "API key copied to clipboard.",
        "show_once_warning": "Copy this key now. For security reasons, it will not be shown again after you close this dialog.",
        "show_once_info": "The key will be shown once after generation. Store it securely, it cannot be retrieved again.",
        "status": {
            "active": "Active",
            "revoked": "Revoked",
            "expired": "Expired"
        }
    },
    "employee": {
        "date_of_birth": "Required to issue you a card. You can correct it at any time, but not remove it, and nobody else in finway is shown it."
    },
    "date_of_birth_required": "For regulatory reasons in our card programme, we have to ask for your date of birth before you can continue.",
    "date_of_birth_private": "Your date of birth is not shown in finway and is visible only to you.",
    "prefilled_approver": "Pre-filled with automatically determined approver.",
    "vendor_rule": "If a vendor rule for this vendor is set, the cost center 1, cost center 2, and expense account will be determined automatically.",
    "allowed_invoice_types": "Allowed file types: PDF, JPG, PNG.",
    "allowed_delivery_note_types": "Allowed file types: PDF, JPG, PNG. Max file size: 5 MB.",
    "allowed_img_types": "Allowed file types: JPG/JPEG. Max file size: 5 MB.",
    "yearly_price": "This is $ {{price}} yearly.",
    "monthly_price": "This is $ {{price}} monthly.",
    "uploading_img": "Uploading image...",
    "uploading_file": "Uploading file...",
    "responsible_user": "You can only select an admin or approver as the responsible.",
    "email_update": "You need to verify a new email address before it becomes active.",
    "ocr": {
        "captured": "Captured",
        "not_captured": "Failed",
        "in_progress": "In progress",
        "make_sure_ocr_source_is_selected": "Please make sure that the correct OCR source is selected in the rightmost column.",
        "iban_mismatch": "OCR detected a different IBAN. Adjustments will affect only this request, not the vendor master data.",
        "bic_mismatch": "OCR detected a different BIC. Adjustments will affect only this request, not the vendor master data.",
        "failed_hint": "OCR failed. One possible reason is that the file size exceeds the {{fileSizeLimitMb}} MB OCR limit. Please check the file size and format."
    },
    "inbox_invoice": {
        "file_name": "File name",
        "upload_date": "Upload date",
        "ocr": "OCR",
        "vendor": "Vendor",
        "action": "Action",
        "uploaded_by": "Uploaded by",
        "invoices_from_inbox": "Invoices from inbox",
        "expense_details": "Expense details",
        "invoice_details": "Invoice details",
        "docs_needed_expenses": "Expenses with status 'Documents needed'",
        "ocr_source": "OCR",
        "gross_amount": "Gross amount",
        "amount": "Amount"
    },
    "verify_email": {
        "title": "Email Confirmation Successful",
        "message": "Your email address is now confirmed and can be used for your next login."
    },
    "card_info_required": "You need to re-enter your card information.",
    "empty_state": {
        "requests": {
            "title": "No outstanding requests",
            "message": "Add a new request to show it here."
        },
        "todo_done": {
            "title": "Good job, you're done with all your To-dos.",
            "message": "Add a new request with the plus-button on the top right."
        },
        "procurement": {
            "title": "No outstanding purchase orders.",
            "message": "Approved purchase orders will appear here to be reviewed."
        },
        "review": {
            "title": "No outstanding requests",
            "message": "Approved requests will appear here to be reviewed."
        },
        "all": {
            "title": "No requests.",
            "message": "All requests will be listed here."
        },
        "archive": {
            "title": "No requests.",
            "message": "Archived requests will be listed here."
        },
        "pay_export": {
            "title": "No outstanding requests",
            "message": "Reviewed requests will appear here to be paid and exported."
        },
        "subscriptions": {
            "title": "Add your first subscription",
            "message": "Add your first subscriptions to show them in an overview table here."
        },
        "subscriptions_employees": {
            "title": "Nothing here yet",
            "message": "An approved subscription will appear here."
        },
        "employees": {
            "title": "Add your first employee",
            "message": "Add your first employees to show them in an overview table here."
        },
        "vendors": {
            "title": "Add your first vendor",
            "message": "Add your first vendors to show them in an overview table here."
        },
        "workflows": {
            "title": "Add your first workflow",
            "message": "Add your first workflow to show them here."
        },
        "cost_centers": {
            "title": "Add your first cost center 1",
            "message": "Add your first cost centers 1 to show them in an overview table here."
        },
        "cost_centers_approver": {
            "title": "Nothing here yet",
            "message": "Please ask your admin to assign your first cost center 1."
        },
        "transactions": {
            "title": "No transactions yet",
            "message": "Please start the matching process to display transactions here."
        },
        "kyb": {
            "submitted_title": "Documents sent",
            "message_submitted": "All KYB documents are handed in. The verification process can take up to 3 business days. The virtual and physical cards can be used after a successful business verification.",
            "button_home": "Dashboard",
            "button_next": "Next",
            "non-admin_title": "The finway cards can be used shortly",
            "message_non-admin": "Your business needs to be verified to be able to use the cards.",
            "start_title": "KYB - KNOW YOUR BUSINESS",
            "start_subtitle": "for activating the card feature",
            "message_start": "By completing the KYB process you will be able to issue virtual and physical cards to manage your spending more easily. The KYB approval process can take up to three business days, and can only be started by one of the Admins. The KYB process needs to be finished by the person, who starts it.",
            "loading_title": "Data is being processed",
            "loading_info": "This process will take a couple of seconds"
        },
        "creditCard": {
            "no_cards_yet": {
                "title": "No cards created yet",
                "message": "Your cards will be shown on this page"
            },
            "no_active_cards": {
                "title": "No active cards yet",
                "message": "Your active cards will be shown on this page"
            }
        },
        "inbox": {
            "title": "Your inbox is empty",
            "message": "All incoming invoices will be listed here."
        },
        "funding_history": {
            "title": "No funding transactions yet",
            "message": "Once you send money to your wallet, it will appear here."
        },
        "account_statements": {
            "title": "No account statements yet",
            "message": "At the end of every month, an account statement will be shown here."
        },
        "folder": {
            "message": "No requests have been added yet."
        },
        "wallet_iban_process": {
            "title": "Wallet creation in process",
            "message": "Please click the button below to finish the wallet creation."
        }
    },
    "sepa_xml_already_generated": "SEPA XML was already generated.",
    "finish_web_form": "Please finish the web form...",
    "fetching_bank_transactions": "Fetching bank transactions...",
    "more_interfaces_available": "If you are missing any accounts, try to connect more interfaces.",
    "expense_filter": {
        "amount": "For subscriptions, this refers to the yearly price."
    },
    "matched": "Matched",
    "downloading": "Downloading",
    "downloaded": "Downloaded",
    "failed": "Failed",
    "click_to_repair": "click to repair",
    "action_in_progress": "Action in progress...",
    "action_required": "Action required",
    "connecting": "Connecting",
    "matching": {
        "csv_mapping_verify": "Please verify that the columns were correctly mapped.",
        "csv_mapping_verify_description": "If all values of the following parameters are identical, the transaction is only imported once to avoid duplicates: Amount, Date, IBAN, Supplier, and Description.",
        "card_transaction_info": "This is a card transaction which implies that the matching to the corresponding expense happens automatically and should not be matched manually.",
        "cash_card_transaction_info": "This is a cash withdrawal transaction for a card. These kind of transactions are not handled within finway.",
        "pending_transaction_info": "This transaction is pending and has not been completed yet.",
        "failed_transaction_info": "This transaction has failed.",
        "failed_transaction_info_for_reason": "This transaction has failed for the following reason: {{reason}}.",
        "import_in_progress": {
            "title": "Transaction import in progress",
            "message": "Bank transactions are currently being downloaded and matched."
        },
        "matching_in_progress": {
            "title": "Transaction matching in progress",
            "message": "Bank transactions are currently being matched against expenses."
        },
        "pending_bank_transaction": {
            "message": "<0> Pending transaction: </0> This transaction is in status pending, because the payment status feedback has not been provided by the bank yet. If the status remains pending for several days, we recommend you to please inquire more details from your bank.",
            "tooltip": "This pending transaction is waiting for an update from the bank"
        }
    },
    "email_verification_needed": {
        "title": "Email verification needed",
        "message": "Your new email address only becomes active once you verified it."
    },
    "loading_data": "Loading data...",
    "no_search_data_found": {
        "title": "No search results found",
        "message": "Please try with another keyword."
    },
    "no_filter_data_found": {
        "title": {
            "vendor": "No vendor found.",
            "employee": "No employee found.",
            "cost_center_1": "No cost center 1 found.",
            "transaction": "No transaction found.",
            "workflow": "No workflow found.",
            "subscription": "No subscription found.",
            "card": "No card found.",
            "purchase_order": "No purchase order found.",
            "delivery_note": "No delivery note found."
        },
        "message": "Please try another search or add the missing entry.",
        "message_approver": "Please try another search."
    },
    "no_linking_data_found": {
        "invoice": {
            "preview": "You can start linking invoices once the purchase order is fully approved.",
            "enabled": "You can now link invoices to this purchase order."
        },
        "delivery_note": {
            "preview": "You can start linking delivery notes once the purchase order is fully approved.",
            "enabled": "You can now link delivery notes to this purchase order."
        }
    },
    "cards": {
        "pin_blocked": "The PIN for this card is blocked due to too many incorrect entries. Please contact finway support to unblock the card. Only an admin can unblock the card in the options menu, after finway support has unblocked the card.",
        "one_time_card_creation_on_approval": "Approving will create a one-time virtual card to be used for this expense with the requester as the cardholder.",
        "subscription_card_creation_on_approval": "Approving will create a virtual card attached to the subscription with the requester as the cardholder.",
        "window": {
            "no_edit_sub_card": "Derived from attached subscription.",
            "no_edit_one_time_card": "Derived from attached expense."
        },
        "ask_admin_to_issue": "Ask an admin to issue a card.",
        "card_being_generated": "The card is currently being issued. This might take a up to a minute.",
        "fetching_pin": "Fetching PIN...",
        "card_pin_info": "This is the PIN for your physical card. You can only change it at an ATM.",
        "finish_onboarding_part_one": "You have been enrolled in the cards program. Please finish  ",
        "finish_onboarding_part_two": " in order to use your cards.",
        "finish_onboarding_mobile": "You are enrolled to the card program but your phone number is not verified. Please complete ",
        "disabled_auto_recharge": "This card cannot be auto recharged.",
        "cannot_change_requester_with_attached_card": "Requester cannot be changed since a card was already created.",
        "demo": {
            "title": "This is a demo instance.",
            "message": "That means that these are not real cards and they cannot be used to purchase any real world products."
        },
        "limit_change_request": "{{userName}} requested a limit change on card '{{cardName}}'",
        "current_limit_and_requested_limit": "Current limit: {{currentLimit}}. Requested limit: {{requestedLimit}}.",
        "pending_limit_request": "Pending request for a limit increase on this card to {{requestedLimit}}.",
        "limit_padded": "This amount has been added to the limit to compensate for possible currency fluctuations. It is not a fee.",
        "bank_transfer_funding": "Your wallet is your finway bank account connected to your finway cards. To use your cards, make sure your wallet has enough funds. Please make a bank transfer to the following bank account to fund your finway-wallet. If you transfer more than €100,000 within 30 days, we'll need to verify the source of the funds (SoF). In that case, you may need to fill out a digital Source of Funds form. Until the check is complete, the funds will be on hold. For Instant Credit Transfers exceeding €30,000 within 30 days, the funds will be immediately rejected without any verification. <0>Read more here</0>",
        "direct_bank_transfer_funding": "Your wallet is your finway bank account connected to your finway cards. To use your cards, make sure your wallet has enough funds. Enter the amount you'd like to transfer from your default bank account below. If you transfer more than €100,000 within 30 days, we'll need to verify the source of the funds (SoF). In that case, you may need to fill out a digital Source of Funds form. Until the check is complete, the funds will be on hold. <0>Read more here</0>",
        "bank_transfer_link": "https://help.finway.de/en/articles/160658-your-wallet-and-payment-with-cards ",
        "physical_card_costs": "A physical card costs 3 EUR per month.",
        "alternative_email_address_required": {
            "title": "Alternative email address required",
            "message": "To verify and manage the card enrollment for this company, please add an alternative email address since the main email address is already used in another company."
        },
        "limit_buffer": "€ {{available}} limit buffer available",
        "limit_buffer_spent": "Limit buffer has been spent",
        "update_expense_amount_on_card_transaction": "Card transactions will automatically adjust the amount of the matched autogenerated request.",
        "ask_support_to_enable_card_program": "Ask our support to enable the card program.",
        "ask_support_to_enable_multi_currency_wallet": "Ask our support to enable the multi currency wallet.",
        "bin_type_warning": "German BIN selected, please note that currently Apple Pay and Google Pay are not yet supported.",
        "card_phone_number_deprecated": "Could an incorrect phone number be linked to this card due to an older system configuration? If so, please contact our Support Team, and we'll be happy to update it for you."
    },
    "corporate": {
        "user_pincode_info": "For security reasons, we need you to create a 4-digit finway PIN that will be required for certain card actions. After entering the finway PIN on request it is valid for 5 minutes and will not have to be re-entered during that time. Also, this finway PIN ist assigned to your private account and should be kept secret.",
        "email_verification": "For compliance and security reasons, we need to verify your email address. An email with a verification code has been sent to your email address. Please enter the code IMMEDIATELY (maximum validity of one hour) below and click next to continue.",
        "mobile_verification": "For compliance and security reasons, we also need to verify your mobile number. A SMS with a verification code has been sent to your mobile number. Please enter the code IMMEDIATELY (maximum validity of 5 minutes) below and click next to continue.",
        "create_account": "In order to successfully conclude the KYB process, please create a business account that will be used for funding your cards by clicking the button below."
    },
    "auto_generated_request": "This request was automatically generated.",
    "tax_deleted": "This tax rate has been deleted.",
    "team_deleted": "This team has been deleted.",
    "employee_deleted": "This employee has been deleted.",
    "employee_no_creditor_number": "No creditor number added yet. Creditor number is needed for travel reimbursement requests and suggested for all reimbursement requests",
    "employee_mileage_rate": "You can add a custom mileage rate here (cent per kilometer). A note about your special rate will be shown when you request a reimbursement.",
    "employee_mileage_rate_apply": "The requester has a custom mileage rate of {{cent_rate}} cent/km that applies to this calculation.",
    "request_net_amount_mismatch": "The sum of net amounts or tax rates across all items does not match the total line -",
    "auto_generated_request_gross_amount_mismatch": "The <strong>total expense amount (Total gross)</strong> does not match the <strong>transaction amount ({{transactionAmount}})</strong>. <br /> If you continue, the expense will be saved with an <strong>incorrect total</strong>. Please review your entries before saving.",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "pending": "Pending",
    "tax_mismatch": "The sum of tax does not match the expense's tax amount.",
    "split_not_hundred_percent": "Expense splitting percentage does not sum to 100%",
    "split": {
        "rounding_error_detected": "Split rounding discrepancy: The (total) gross amount(s) are optimized for export to DUO. For CSV export, please adjust the amounts manually on a line basis, if needed (amount fields are unlinked).",
        "rounding_error_non_editable": "Split rounding discrepancy has not been manually adjusted.",
        "has_vertical_discrepancy_gross": "Split rounding discrepancy: There are rounding discrepancies in the gross amounts (gross amounts to not add up to total gross amount). Please adjust the gross amounts manually for DUO transfer.",
        "has_horizontal_discrepancy": "Split rounding discrepancy: There are rounding discrepancies found on a line basis (e.g. net + VAT does not equal gross). Please adjust the amounts manually, if needed for your CSV export or other purposes.",
        "has_both_discrepancy": "Split rounding discrepancy: Rounding discrepancies found both in the gross amounts (gross amounts do not add up to total gross amount), as well as on a line basis. Please adjust the amounts manually to enable DATEV export."
    },
    "filled_by_ocr": "Automatically extracted by OCR.",
    "missing_vendor_or_cc": {
        "title": "Missing information",
        "message": "This request was auto-generated and you need to manually select a cost center and vendor first. Only then this request can be further processed."
    },
    "missing_cc": {
        "title": "Missing information",
        "message": "This request has a missing cost center data. Only then this request can be further processed."
    },
    "item_gross_total_mismatch": {
        "main": "The total gross amount of the items ({{items_gross}}) does not match the total gross amount of the expense ({{expense_gross}}) -",
        "prompt": "adjust now."
    },
    "banking": {
        "consent_required": "Bank connection {{bank_name}} ({{bank_code}}) requires your consent to be able to retrieve data from the bank. ",
        "this_consent_required": "This bank connection requires your consent to be able to retrieve data from the bank. ",
        "currently_downloading": "Bank connection {{bank_name}} ({{bank_code}}) is currently downloading transaction data. Please wait until this process resolves, as it could take up to a day to complete.",
        "this_currently_downloading": "This bank connection is currently downloading transaction data. Please wait until this process resolves, as it could take up to a day to complete.",
        "automatic_payment_disabled": "Automatic bank payment matching is currently disabled.",
        "outdated_data_displayed": "Outdated data might be displayed.",
        "balance_missing": "Balance is not available",
        "balance_missing_due_consent": "Consent is missing: Balance is not available",
        "potential_extra_payment_fee": "We only support Euro currency payments. If you pay with a different currency, there may be additional currency conversion fees charged by the receiving bank, including transaction fees for foreign banks outside the EU. <0/> <0/> Fees vary by bank and are out of our control. Review the payment details carefully. Contact the receiving bank for questions. By clicking \"Submit\", you confirm you have read the written above."
    },
    "fetch_table_error": "Please try loading the table again by clicking on the \"reload\" button or refreshing the page",
    "liquidity_scenario": "Select a parent scenario to set your assumptions.",
    "bu_code_datev_compliance": "At least one of the BU codes is incompatible with DATEV.",
    "bu_code_datev_compliance_detail_warning": "One or multiple BU codes used in this request are not compatible with DUO. If you want to export this request to DATEV, please change the BU codes accordingly.",
    "expense_account_code_datev_compliance": "At least one of the expense account codes is incompatible with DATEV.",
    "consolidated_amount_unsafe_datev_compliance": "The total amount does not add up to the sum of the items.",
    "wallet": {
        "auth_factor": {
            "auth_factor_needed": "The withdrawal process requires you to register an authentication device - e.g. a mobile -",
            "verification_code_sent": "A verification code has been sent to your mobile device. With the code you can enroll your mobile as an authentication device for the wallet withdrawal process."
        },
        "wire_transfer": {
            "verification_code_sent": "A verification code has been sent to your mobile device. Please enter the code here to continue with the transfer execution."
        },
        "verification_of_payee": {
            "result": {
                "MATCH": "The name you provided matches the name registered to this IBAN. You can safely proceed with the payment.",
                "CLOSE_MATCH": "The name you provided is similar but not identical to the name registered to this IBAN. Review the registered name carefully before processing - sending to the wrong account may be unrecoverable.",
                "NO_MATCH": "The name you provided does not match the name registered to this IBAN. We strongly recommend to cancel this payment.",
                "NOT_POSSIBLE": "The name could not be verified because the receiving institution does not support Verification of Payee. Please check the payee details carefully before you proceed."
            }
        },
        "generating_statements_in_progress": {
            "title": "Generating account statements",
            "message": "One or more account statements are currently being generated. This could take a while."
        }
    },
    "download_the_sheet_file_template": "Download the sheet template and insert your data.",
    "you_can_close_this_window": "You can close this window now. A notification will appear with the upload results when operation is complete.",
    "validating_data": "Validating data...",
    "import_data": "Importing data...",
    "awesome_your_upload_will_start_now": "Awesome! The upload will start now. You can close this window now. A notification will appear with the upload results when operation is complete. If after a while you don't receive a notification, please try refreshing the page.",
    "simply_get_started_by_downloading_our_template": "Simply get started by downloading our template, adding your data and uploading it to finway.",
    "check_data_upload_result": "You can check the data upload result & find a detailed error log below.",
    "get_started_uploading_data": "Get started by uploading your data in finway!",
    "liquidity_management": {
        "opening_balance": "Opening balance",
        "total_income": "Total income",
        "total_spending": "Total spending",
        "cashflow_cumulated": "Cashflow cumulated",
        "final_balance": "Final balance",
        "planned_transaction_amount": "Create inflows by adding a positive (+) amount or outflows by adding a negative (-) amount.",
        "edit_planned_cashflow": "Edit planned cashflow",
        "account_currency_alert": "When connecting your bank accounts please be aware that the tool can currently only handle one currency at a time.",
        "no_account_connected": "In order to see your account balance, first you must connect at least one of your accounts.",
        "no_account_connected_banner": "To view your actual data and get the most value out of this tool, please connect your bank account(s) first.",
        "no_forecast": "To view your actual vs. plan forecast in this chart, please set up your forecast planning in the cashflow planning table first.",
        "percentages_are_rounded": "Percentages are rounded to absolute numbers."
    },
    "transaction_categories": {
        "default_creation": {
            "title": "Default transaction category creation in progress",
            "message": "Default transactions categories are currently being created. This should only take a moment. Please wait patiently."
        }
    },
    "cannot_be_transferred_to_datev": "This information is just for internal reporting & cannot be transferred to Datev due to Datev restrictions.",
    "archive": {
        "expense_initial_display": {
            "title": "Load your archive to view all requests.",
            "message": "Click here to select a time period or apply the filter/search option. This will allow you to load the data.",
            "warning": "Search for expenses based on the invoice number, expense description, description/reason for trip, item names, expense number, total amount, vendor, requester, or approver."
        },
        "transaction_initial_display": {
            "title": "Load your archive to view all transactions.",
            "message": "Click here to select a time period or apply the filter/search option. This will allow you to load the data."
        },
        "expenseArchiveAfterXDays_settings": "The calculation of the archiving time is based on the performance date. The expense will be archived on the following day.",
        "transactionArchiveAfterXDays_settings": "The calculation of the archiving time is based on the transaction date. The transaction will be archived on the following day.",
        "expense_search_info": "The archiving period is based on the performance date.",
        "transaction_search_info": "The archiving period is based on the transaction date."
    },
    "changing_the_limit_of_the_card_will_top_it_up": "Changing the limit of the card will top up debit cards.",
    "sit_back_and_wait": "Action in progress. Sit back and enjoy a sip of your coffee.",
    "export_in_progress": "Export is in progress, this may take a little - sit back and enjoy a sip of your coffee.",
    "category_will_be_a_subcategory": "If you set this field, the category created will be a subcategory of the selected parent category.",
    "exported_as": "Exported as",
    "export_information": {
        "all": "All",
        "invoices": "Invoices",
        "datev_invoice_csv": "DATEV Invoice CSV"
    },
    "upgrade_version": {
        "title": "Upgrade now to get your all-in-one financial Operating System",
        "1": "Spend management & cashflow planning in one tool",
        "2": "Streamlined processes for spend & cashflow management",
        "3": "A single source of truth for financial health data",
        "4": "Embedded banking",
        "5": "3-way-matching & embedded OCR",
        "6": "Physical and virtual cards",
        "7": "Apple and Google Pay",
        "8": "Powerful workflows & integrations",
        "9": "Mobile Apps for Android & iOS",
        "10": "Vendor & subscription management",
        "11": "Reporting and real-time data insights"
    },
    "upgrade_banner": {
        "title": "Upgrade your plan and unlock the entire finway financial OS",
        "description": "Streamline and digitalize your financial processes in one operating system. Easily manage all invoices, subscriptions, approval processes and smart company cards without friction."
    },
    "not_categorizable": "Not categorizable",
    "roles": {
        "system_rights": "System admin rights allow managing roles & rights, companies, users, authentication and billing.",
        "auditor": "Auditors can view everything, but not edit anything. We recommend using this role for external auditors, tax advisors, etc.",
        "admin": "Admins view and edit everything except for system admin tasks.",
        "approver": "Approvers have the rights of an employees, but can additionally approve requests and be added to workflows as approvers. They can also see all requests of their team across the tool. By approving card requests, they can also generate a card for such requests.",
        "employee": "Employees can create requests (purchase, invoice, reimbursement) for one-time or recurring expenses. They can view their own requests, cards, subscriptions, invoices, see the status of their request and manage their own data in the employee section."
    },
    "per_diem": {
        "please_select": "Please select every meal and/or accommodation that your company paid for, provided, or that you expensed separately",
        "foreign_trip_prompt": "For foreign trips, please only add your actual destination, not your home country/city.",
        "total_reimbursable_amount": "Total reimbursable amount",
        "transfer_date": "Date of arrival in your next destination",
        "transfer_time": "Local time of arrival in your next destination",
        "reimbursement_calc": "The deduction of the allowance rate for meals (e.g. 20% for breakfast) is calculated against the full day allowance rate. Note for half day allowances: Even if the total deduction exceeds the half day allowance, it can never be negative and will be set to 0 EUR for that day.",
        "reload": "We’ve noticed you made date changes. The reimbursement table must be recalculated, please synchronize the table again."
    },
    "expense_tag": {
        "not_found": "No tags found",
        "added_already": "Tag is already added"
    },
    "add_audit_trail_to_invoice_export": "The audit trail is added as an additional file and included in export formats with invoices, except for the DATEV invoice CSV. It can also be downloaded manually.",
    "vendor_creation_for_all": "When activated, all users of this company can create vendors. Regardless of this setting, all users can suggest vendors.",
    "tagging_feature_enable": "The tagging feature allows users to add tags to requests, e.g. to indicate if a request is urgent. Admins can create/delete tags, other roles can use existing tags. If you want anyone to be able to add/delete tags, please also select the next option",
    "editing_tags_enable": "Enable all roles to create and delete new tags",
    "allow_all_to_update_absences": "By default, only Admins can set up absences for themselves and other roles. By activating this option, employee and approver roles will be able to set up their own absences additionally. ",
    "show_cost_centers_ids": "It will show cost center 1 IDs e.g. in all request cost center 1 drop fields",
    "sub_company_aliases": "Add email aliases for each company. This is required to be enrolled in the cards program in multiple companies at the same time. This email is only used during the KYB process.",
    "custom_bank_subject": "You can customize and rearrange your bank subject line as you wish. The template you create below will automatically apply to your next payment.",
    "exchange": {
        "estimate": "Estimation based on*:",
        "paid": "Paid on:",
        "settlement": "Settlement: "
    },
    "data_import_in_progress": "Data import in progress...",
    "expense_payment_flow_information": {
        "is_already_approved_and_paid_enabled": "Requests (except card requests) can be created marked as already approved & paid and all steps except the review and export will be skipped. This is exclusive to the \"Already paid\" process.",
        "is_already_paid_enabled": "Requests (except card requests) can be created marked as already paid and all steps except the review and export will be skipped.",
        "is_report_only_enabled": "Requests (except card requests) can be created only for reporting which will skip all steps except the review."
    },
    "allow_workflow_adjustments": "When activated, all users of this company can adjust workflows. When deactivated, only users with the right \"Overwrite (Workflows)\" can adjust workflows.",
    "mileage": {
        "above_threshold": "The total distance of this trip has surpassed the {{distance}} km tolerance.",
        "above_threshold_prompt": {
            "1": "The distance you have added has exceeded the additional {{distance}} km tolerance. Please",
            "2": "add a reason",
            "3": "to continue with the reimbursement"
        },
        "distance_buffer": "finway automatically calculates the optimal route between all destinations, but users can change the distance manually. Set up the distance buffer in kilometers below. Users will be asked for a reason if the buffer is exceeded.",
        "date": "Used as performance and internal receipt date. For multi-day drives, a performance period can be added additionally."
    },
    "debit_card_limit_buffer": "The lack of a limit buffer for debit card requests can lead to failed card transactions. Choose your default limit buffer (%) below to prevent avoidable card transaction failures.",
    "custom_datev_info": "Customize the content to be exported as DATEV information to DUO for different expense types. Please mind the 120 character limit - extra content will be cut upon export. ",
    "custom_datev_info_footer": "(120 characters are allowed by DUO - additional information will be cut off)",
    "pending_vendor": "Pending vendor",
    "approve_vendor": "After approval, the vendor can be edited",
    "reject_vendor": "Rejecting deletes this vendor",
    "custom_datev_booking_footer": "(60 characters are allowed by DUO - additional information will be cut off)",
    "custom_datev_booking": "Customize the content to be exported as DATEV booking text to DUO. Please mind the 60 character limit - extra content will be cut upon export.",
    "enable_go_to_next_expense": "When enabled, the navigation after an approval from the request detail page changes: the system will navigate to the next request of the same status (instead of displaying the same request with a different status). Applies to “To-dos” and “Review” tabs only.",
    "datev_online_error": {
        "title": "Problem with your DUO connection",
        "invalid_grant": "We have detected a problem with your DUO connection. Please try reconnecting to resolve the issue or reach out to our support.",
        "account_not_found": "Your DUO account couldn't be accessed. This can happen if you link it elsewhere, for example. We automatically disconnected the account - please connect it again in the settings."
    },
    "auto_logout_suggestion": "We recommend an auto-logout interval of less than 24h for security reasons. This setting only gets applied after the next login.",
    "employee_absence_role": {
        "substitutes_not_set_up": "During periods of absence, designated substitutes will handle request approvals on behalf of the original approver.",
        "substitutes_set_up_link": "Substitutes can be configured in the <0>user settings</0>.",
        "substitutes_set_up": "In the event of an absence, the assigned substitute will approve requests. The substitute is automatically notified at the start of the absence."
    },
    "employee_absence_substitutes_banner": {
        "message": "Set up your absence substitutes",
        "description": "Ensure a smooth workflow while you're away! Assign substitutes to keep approvals and processes running without interruptions. \uD83D\uDE80",
        "button": "User Settings"
    },
    "active_substitution_banner": {
        "title": "Active Substitution",
        "you_substituting": "You are currently substituting for {{count}} colleagues:",
        "substituting_name_period": "<strong>{{name}}</strong> from <strong>{{start_date}}</strong> to <strong>{{end_date}}</strong>",
        "substituting_1": "You are currently substituting for <strong>{{name}}</strong> from <strong>{{start_date}}</strong> to <strong>{{end_date}}</strong>.",
        "request_in_todo": "Requests with pending approvals will show on your To-Dos section."
    },
    "data_validation_result_below": "Find the result of the data upload validation below. If there is any error please resolve them before continuing.",
    "data_validation_empty_sheet": "Your sheet is empty. Please make sure you added data to the sheet.",
    "data_import_result_below": "Find the result of the data upload import below.",
    "the_following_entries_will_be": "The following entries will be",
    "the_following_entries_have_been": "The following entries have been",
    "total_imported_entries_on_date": "{{total}} records imported on {{date}}.",
    "on_row": "on row",
    "row": "row",
    "select_fallback_approver": "Please select a fallback approver from a list of suitable approvers.",
    "export_change_history": {
        "message": "Info",
        "description": "The timestamps in the export file are displayed in Universal Time Coordinate (UTC) format."
    },
    "fiscal_year": {
        "select": "Please insert your fiscal year.",
        "dates": "{{start_date}} to {{end_date}}"
    },
    "gross_amount_increased": "Gross amount has increased",
    "csv_number_separator": {
        "title": "Recommendation based on operating system language setting:",
        "german_bold": "German (DE): ",
        "english_bold": " English (US): ",
        "german": "CSV delimiter {;} and amount separator {,}",
        "english": "CSV delimiter {,} and amount separator {.}"
    },
    "request": {
        "update_expense_amount_on_card_transaction": "Card transactions will automatically adjust the amount of this request."
    },
    "datev_compliance_issues": "This request is not compatible to DATEV. If you want to export this request to DATEV please resolve the following issues first:",
    "zero_total_gross_datev_compliance": "Total gross amount of 0 is incompatible with DATEV.",
    "zero_item_gross_datev_compliance": "At least one item has a gross amount of 0 and is incompatible with DATEV.",
    "enroll_fallback_approver": "Please enroll the selected workflow fallback approver into the card program or choose another suitable fallback approver.",
    "folder": {
        "status": {
            "draft": {
                "title": "Submit this folder",
                "description": "Please collect all expenses before submitting."
            },
            "invoice_pending": {
                "title": "Approve folder and requests",
                "description": "Approving folder applies to all included requests.",
                "tooltip": "Does not apply to already approved requests."
            },
            "approved": {
                "title": "Mark this folder as reviewed?",
                "description": "Applies to the folder and all included requests.",
                "tooltip": "Does not apply to requests marked as already reviewed."
            },
            "reviewed": {
                "title": "Pay all requests in this folder?",
                "description": "Pay the folder and included requests.",
                "tooltip": "Does not apply to already paid requests."
            },
            "paid": {
                "title": "Export all requests in this folder?",
                "description": "Export the folder and included requests.",
                "modal": {
                    "title": "Export all requests",
                    "description_1": "One or more requests have been exported before",
                    "description_1_format": "One or more requests have been exported as {{format}} before.",
                    "description_2": " Please define if all requests should be exported, or only those that have not yet been exported.",
                    "format": {
                        "csv": "CSV",
                        "csv_lexware": "CSV Lexware",
                        "datev": "DATEV-XML",
                        "datev_online": "DUO",
                        "sepa": "SEPA-XML",
                        "invoices": "invoices"
                    },
                    "export_all": "Export all",
                    "only_not_exported": "Export only not exported",
                    "confirm": "Export",
                    "cancel": "Cancel",
                    "already_exported": {
                        "message_format": "All expenses have been exported as {{format}} before.",
                        "message": "All expenses have been exported before."
                    }
                }
            },
            "declined": {
                "title": "Rejected folder",
                "description": "This folder has been rejected."
            },
            "done": {
                "title": "Archived folder",
                "description": "This folder is processed and archived."
            }
        }
    },
    "ignored_entries_because_they_exist_in_the_app": "All ignored entries without specific details are ignored because they already exist in the app.",
    "expense_account_code_special_character_warning": "We strictly recommend to NOT enable this option if your company exports to DATEV. This option is useful if use export e.g. to ADDISON. When enabled, you can create expense accounts with special characters and download DATEV XML to import into ADDISON.",
    "ocr_updates": {
        "modal_title": "OCR updates",
        "automatically_recognized_data": "Automatically recognized data",
        "description": "Please review the data that OCR read out. You can select for each field, if its original information should be overwritten by the OCR data.",
        "updates_through_ocr": "Updates through OCR",
        "fields": "fields",
        "original": "original",
        "new": "new",
        "fields_names": {
            "invoiceNumber": "Invoice number",
            "invoiceDate": "Invoice date",
            "currency": "Currency",
            "invoiceDueDate": "Due date",
            "totalNetPrice": "Net amount",
            "taxRate": "VAT %",
            "totalTaxPrice": "VAT amount",
            "totalGrossPrice": "Gross amount",
            "vendor": "Vendor",
            "name": "Item name",
            "itemParent": "Item",
            "merchant": "Merchant",
            "performancePeriod": "Performance Period",
            "netPrice": "Net amount",
            "grossPrice": "Gross amount",
            "taxPrice": "VAT amount",
            "unitPrice": "Unit price",
            "quantity": "Quantity",
            "description": "Description",
            "hospitalityDate": "Hospitality date",
            "performanceDate": "Performance date",
            "costCenter": "Cost center",
            "costCenter2": "Cost center 2"
        }
    },
    "ask_support_to_enable_card_program": "Ask our support to enable or disable the card program.",
    "datev_export_job": {
        "pending": "A DUO export is currently running for this request. Depending on the current load of DATEV, this might take a while. You can check the status manually by",
        "pending_button": "clicking here.",
        "failure_type_enum": {
            "MISSING_ACCOUNT_MONTH": "The latest DUO export for this request has failed because the accounting month is not configured in your linked DUO account. Please check in DUO.",
            "UNSUPPORTED_FILE_TYPE": "The latest DUO export for this request has failed because it is has an invoice that contains an unsupported file format. Please try a different invoice file format e.g. .pdf, .png, .jpeg",
            "ACCOUNT_NOT_FOUND": "The latest DUO export for this request has failed because your DUO account couldn't be accessed. This can happen if you link it elsewhere, for example. We automatically disconnected the account - please connect in the settings.",
            "DAMAGED_INVOICE": "The latest DUO export for this request has failed because it has an invoice that is of a wrong file format. Please try a different invoice file.",
            "UNKNOWN": "The latest DUO export for this request has failed. Please try it again or check out the DATEV import protocol to find out more information.",
            "JOB_NOT_FOUND": "Please try again. If the error persists, contact finway support and provide the error code: JOB_NOT_FOUND",
            "INVALID_DATEV_ACCESS_TOKEN": "The latest DUO export failed for at least one request as the DATEV access token was missing. Please connect in the settings."
        }
    },
    "approval_process": {
        "build_issue": {
            "title": "Approval process could not be created from the triggered workflow \"{{workflowName}}\" due to the following issues: ",
            "final_step_approvers_not_enrolled": "Approver(s) from the final approval step are not enrolled in the cards program ({{approvers}}). Therefore, a final approval step has been added (fallback approver). ",
            "approver_is_requester": "Approver equals requester ({{approver}}). Superior fallback failed because requester has no superior.",
            "fallback_approver_is_requester": "Fallback approval failed because fallback approver equals requester. ({{approver}})",
            "fallback_approver_not_enrolled": "The fallback approver is not enrolled in the cards program. ({{approver}})",
            "superior_not_enrolled": "Superior fallback failed because superior is not enrolled in cards program. ({{approver}})",
            "all_steps_skipped": "All workflows steps were skipped due to not meeting the conditions.",
            "estimated_past_steps": "We enhanced the approval overview and forecast. Past approvers for old requests might be incorrect. Please check the comments in this case."
        }
    },
    "sso": {
        "has_been_de_forced": "SSO has been successfully de-forced"
    },
    "duo_import_protocol_info": "Only the import protocol of the latest export process is shown below.",
    "auth_error": {
        "login_failed": "Login failed",
        "text": "Your login request was unsuccessful. This might be due to declined MFA authorization, invalid SSO configuration or lack of permissions."
    },
    "gobd_compliance": {
        "ask_support_to_enable": "finway GmbH enables GoBD-compliant work in accordance with IDW PS 880, but does not assume any product liability for the product settings you select. GoBD-compliant work can have far-reaching effects, e.g. in the case of an audit. Please consult your tax advisor before requesting a change. More information <0>here</0>. Please contact support to activate GoBD-compliant working.",
        "link": "https://help.finway.de/en/articles/209564-gobd-certificate-implementation-in-finway"
    },
    "new_password_panel": {
        "password_policy": {
            "title": "We have increased our security standards, please create a new password with the following criteria:",
            "1": "Must not contain your email address, first name, or last name.",
            "2": "Must be at least 8 characters long.",
            "3": "Must not contain any inappropriate wording.",
            "4": "Must have at least one special symbol (!, @, #, $, % etc.)."
        }
    },
    "sync_per_diem_request": {
        "action": "Synchronize",
        "text": "We've noticed you made changes. The reimbursement table must be recalculated, please synchronize the table again."
    },
    "email_forwarding_address": "You can use this email address to forward your invoices to your finway invoice inbox via email.",
    "will_receive_reimbursement_payment": "will receive the reimbursement payment for this request.",
    "reset_demo_data_in_progress": "Demo data reset is in progress, this may take a little - sit back and enjoy a sip of your coffee.",
    "active": "Active",
    "inactive": "Inactive",
    "beneficiary": {
        "document_expired_warning": {
            "title": "Action Required: Update Your Identity Document for the finway card program",
            "message": "The identity document for personal verification of {{firstName}} {{lastName}} is expiring on {{documentExpiryDate}}. To avoid any service interruptions, please upload a new unexpired document, else all of your accounts/cards will be restricted from transacting on {{identityRestrictionDate}}. Find out how to upload an identity document <0>here</0>.",
            "link": "https://help.finway.de/en/articles/160661-kyb-process-request-card-functionality#h_4394a5a454"
        },
        "account_restricted": {
            "title": "Action Required: Identity Document expired",
            "message": "The identity document for personal verification of {{firstName}} {{lastName}} expired hence all of your accounts/cards are restricted from transacting. Find out how to upload an identity document <0>here</0>.",
            "link": "https://help.finway.de/en/articles/160661-kyb-process-request-card-functionality#h_4394a5a454"
        }
    },
    "expense_discount": {
        "expired": {
            "title": "Warning - Discount expired",
            "message": "One or more requests contain an expired discount and are therefore not taken into account for the payment. <br/> <0/> All expired discounts will be deleted automatically from the requests after payment is confirmed."
        },
        "sepa_export": {
            "expired": {
                "title": "Warning - Discount expired",
                "message": "One or more requests include an expired discount. The full (non-discounted) amount will be applied to the payment. <br/> <0/> All expired discounts will be deleted automatically from the requests after the request was marked as paid."
            }
        }
    },
    "company_tz_change": "Once the company is created you can no longer change the company time zone. Please get in touch with your support manager if needed.",
    "posting_period": {
        "tooltip": "Specifies the period in which the invoice is posted. <0>Learn more.</0>",
        "link": "https://help.finway.de/en/articles/200682-gobd-compliant-invoice-belegfunktion"
    },
    "data_uploader": {
        "entry_limit": "All data entries that exceed the 1000th entry line per sheet will not be imported."
    },
    "company_settings": {
        "update_sepa_version_help": "Ask our support to enable this SEPA xml version."
    },
    "employee_absence": {
        "modal": {
            "modal_headline": "My Absence Substitute",
            "primary_substitute": "Primary substitute",
            "secondary_substitute": "Secondary substitute",
            "cancel": "Cancel",
            "save": "Save",
            "no_option": "No data",
            "no_secondary_substitute_set": "No secondary substitute set"
        },
        "not_card_program_alert_banner": {
            "title": "{{userName}} is not part of the card program",
            "message": "Card request approvals will either be handled by an admin or put on hold until you return."
        }
    },
    "purchase_order": {
        "billing": {
            "message": "Purchase orders now available!",
            "description_1": "Try our advanced purchase order management with linking to invoices on line-item level for free during the pilot period.",
            "description_2": "Premium features will be available with paid plans later.",
            "more_info": "More information",
            "link": "https://help.finway.de/en/articles/396998-purchase-orders-pos-and-invoice-matching"
        },
        "card": {
            "one_time_card_creation_on_approval": "A card will be created once the purchase order is approved by approver.",
            "one_time_card_creation_on_procurement": "A card will be created once the purchase order is approved by procurement.",
            "one_time_card_missing": "Card could not be automatically created with approval, because the approver was not in the card program, please create the card manually."
        },
        "empty_table": {
            "title": "Add your first purchase order",
            "text": "Add your first purchase orders to show them in an overview table here.",
            "button": "Create purchase order"
        }
    },
    "delivery_note": {
        "billing": {
            "message": "Delivery notes now available!",
            "description_1": "Try our enhanced order management now also with delivery notes. Link delivery notes to orders at the item level – free during the pilot phase.",
            "description_2": "Advanced premium features will be available in paid plans after the pilot phase.",
            "more_info": "More information",
            "link": "https://help.finway.de/en/articles/425826-lieferschein-integration"
        },
        "empty_table": {
            "title": "Add your first delivery note",
            "text": "Add your first delivery notes to show them in an overview table here.",
            "button": "Create delivery note"
        }
    },
    "skr42": "When this option is enabled, the cost center 1 and cost center 2 fields are swapped in all export formats. Note: This also applies to exports to DATEV Unternehmen Online.",
    "self_issued_receipt": "Use only if the original receipt is missing - missing originals may cause your company VAT loss. Learn more in our <0>Help Center</0>.",
    "self_issued_receipt_link": "https://help.finway.de/en/articles/704918-self-issued-receipt",
    "credit_note_negative_amount": "You can enter the amounts as shown on the credit note. They are saved as negative values.",
    "self_issued_receipt_reason": "The reason will be embedded in your self-issued receipt attached to this request."
}
